import { render, staticRenderFns } from "./weChatShare.vue?vue&type=template&id=bf49c43e&scoped=true"
import script from "./weChatShare.vue?vue&type=script&lang=js"
export * from "./weChatShare.vue?vue&type=script&lang=js"
import style0 from "./weChatShare.vue?vue&type=style&index=0&id=bf49c43e&prod&lang=scss"
import style1 from "./weChatShare.vue?vue&type=style&index=1&id=bf49c43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf49c43e",
  null
  
)

export default component.exports